import { render, staticRenderFns } from "./PermissionsHomeView.vue?vue&type=template&id=6a04ad05&scoped=true"
import script from "./PermissionsHomeView.vue?vue&type=script&lang=js"
export * from "./PermissionsHomeView.vue?vue&type=script&lang=js"
import style0 from "./PermissionsHomeView.vue?vue&type=style&index=0&id=6a04ad05&prod&lang=scss&scoped=true"
import style1 from "./PermissionsHomeView.vue?vue&type=style&index=1&id=6a04ad05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04ad05",
  null
  
)

export default component.exports